import React from 'react';
import { ExperimentsContext } from './ExperimentsContext';
import { useFetchExperiments } from './useFetchExperiments';
import { extreactOptions } from './utils';
export var ExperimentsProvider = function (props) {
    var value = useFetchExperiments(extreactOptions(props));
    return (React.createElement(ExperimentsContext.Provider, { value: value }, props.children));
};
//# sourceMappingURL=ExperimentsProvider.js.map